import React from 'react';
import useUIStore from '@/app/store/ui.store';
import { AgencyHeader } from './AgencyHeader';
import { PersonaSidebar } from './navigation';
import { OfflineBanner } from './OfflineBanner';

interface AgencyAppLayoutProps {
  children: React.ReactNode;
}

export const AgencyAppLayout: React.FC<AgencyAppLayoutProps> = ({ children }) => {
  const { density } = useUIStore();

  React.useEffect(() => {
    document.body.setAttribute('data-density', density);
  }, [density]);

  return (
    <div className="min-h-screen bg-bg text-text flex">
      <PersonaSidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <OfflineBanner />
        <AgencyHeader />
        <main className="flex-1 overflow-auto p-6">{children}</main>
      </div>
    </div>
  );
};

export default AgencyAppLayout;
